import { render } from "./networkDetector.vue?vue&type=template&id=47335ded&scoped=true"
import script from "./networkDetector.vue?vue&type=script&lang=js"
export * from "./networkDetector.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=47335ded&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wjlfi\\Desktop\\1v1vue3\\demos\\basic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47335ded"]])

export default __exports__